import { functions } from "@src/firebase.config";

const addToMailingList = functions.httpsCallable("addToMailingList");

export default async email => {
  const { data } = await addToMailingList(email);

  return data;
};
